export default __webpack_public_path__ + "static/blog-05-900x678-d4981cc07939bcdacc76830f1498df88.jpg";